import { useLang } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { tr } = useLang();
  const items = tr("home").marquee || [];

  const Track = ({ hidden }) => (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-ivory/45 md:text-3xl">{item}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold/60" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className="marquee-band relative overflow-hidden border-y border-gold/15 bg-navy-light py-6">
      <div className="animate-marquee flex w-max">
        <Track />
        <Track hidden />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-navy-light to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-navy-light to-transparent" />
    </div>
  );
}
